/*eslint-disable*/export const messages=JSON.parse("{\"icon.title.messages\":\"Speech bubbles\"}");